import { FormControl, FormControlProps } from "@mui/material";
import React from "react";

export type WcFormControlProps = FormControlProps;

export const WcFormControl = ({ children, ...props }: WcFormControlProps) => <FormControl {...props}>{children}</FormControl>;
